const gout_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"form1[0].#subform[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"form1[0].#subform[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"form1[0].#subform[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"Please identify the evidence reviewed and the date range",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Evidence review",
         number: "0"
      },
      "maxLength":540,
      "presidence":"Yes",
      "radioGroup":"form1[0].#subform[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"form1[0].#subform[0].IdentifyEvidence[0]",
      "textanswer":""
   },

   {
      "question":"Does ##name## have any joint involvement (e.g., pain, limitation of motion, joint deformity) attributable to the arthritis condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "JOINT INVOLVEMENT",
         number: "3A"
      },
      "presidence":"Yes",
      "ref":2,
      "dbqName_yes":"form1[0].#subform[4].Yes7[0]",
      "dbqName_no":"form1[0].#subform[4].No7[0]",
      "answer":"",
   },
   {
      "question":"Check all the joints attributable to arthritis condition that apply",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "show": false,
      "small": true,
      "refId":1,
      "cols": 2,
      "section": {
         page: "3",
         title: "JOINT INVOLVEMENT",
         number: "3A"
      },
      "questions":[
         {
            "main":"Right Shoulder",
            "dbqName":"form1[0].#subform[4].RSHOULDER[0]",
            "answer":""
         },
         {
            "main":"Right Elbow",
            "dbqName":"form1[0].#subform[4].RELBOW[0]",
            "answer":""
         },
         {
            "main":"Right Wrist",
            "dbqName":"form1[0].#subform[4].RWRIST[0]",
            "answer":""
         },
         {
            "main":"Right Hand/Fingers",
            "dbqName":"form1[0].#subform[4].RHAND[0]",
            "answer":""
         },
         {
            "main":"Right Hip",
            "dbqName":"form1[0].#subform[4].RHIP[0]",
            "answer":""
         },
         {
            "main":"Right Ankle",
            "dbqName":"form1[0].#subform[4].RANKLE[0]",
            "answer":""
         },
         {
            "main":"Right Knee",
            "dbqName":"form1[0].#subform[4].RKNEE[0]",
            "answer":""
         },
         {
            "main":"Right Foot/toes",
            "dbqName":"form1[0].#subform[4].RFOOT[0]",
            "answer":""
         },
         {
            "main":"Cervical spine",
            "dbqName":"form1[0].#subform[4].CERVICAL[0]",
            "answer":""
         },


         {
            "main":"Left Shoulder",
            "dbqName":"form1[0].#subform[4].LSHOULDER[0]",
            "answer":""
         },
         
         {
            "main":"Left Elbow",
            "dbqName":"form1[0].#subform[4].LELBOW[0]",
            "answer":""
         },         
         {
            "main":"Left Wrist",
            "dbqName":"form1[0].#subform[4].LWRIST[0]",
            "answer":""
         },         
         {
            "main":"Left Hand/Fingers",
            "dbqName":"form1[0].#subform[4].LHAND[0]",
            "answer":""
         },         
         {
            "main":"Left Hip",
            "dbqName":"form1[0].#subform[4].LHIP[0]",
            "answer":""
         },
         {
            "main":"Left Knee",
            "dbqName":"form1[0].#subform[4].LKNEE[0]",
            "answer":""
         },
         
         {
            "main":"Left Ankle",
            "dbqName":"form1[0].#subform[4].LANKLE[0]",
            "answer":""
         },         
         {
            "main":"Left Foot/toes",
            "dbqName":"form1[0].#subform[4].LFOOT[0]",
            "answer":""
         },
         
         {
            "main":"Thoracolumbar spine",
            "dbqName":"form1[0].#subform[4].THORACOLUMBAR[0]",
            "answer":""
         },
         {
            "main":"Sacroiliac joints",
            "dbqName":"form1[0].#subform[4].SACROILIAC[0]",
            "answer":""
         }        
      ],
      "answer":""
   },
   {
      "question":"For all the joints checked on the previous screen, describe involvement",
      "sub":"",
      "type":"textarea",
      "maxLength":340,
      "show": false,
      "refId":2,
      "section": {
         page: "3",
         title: "JOINT INVOLVEMENT",
         number: "3A"
      },
      "options":[],
      "dbqName":"form1[0].#subform[4].BriefSummary[0]",
      "answer":""
   },

   {
      "question":"Does ##name## have any involvement of any body systems, other than joints, attributable to the arthritis condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "SYSTEMIC INVOLVEMENT OTHER THAN JOINTS",
         number: "4A"
      },
      "presidence":"Yes",
      "ref":2,
      "dbqName_yes":"form1[0].#subform[4].Yes10[0]",
      "dbqName_no":"form1[0].#subform[4].No10[0]",
      "answer":"",
   },   
   {
      "question":"Indicate systems involved",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": false,
      "small": true,
      "refId":1,
      "cols": 2,
      "section": {
         page: "3",
         title: "SYSTEMIC INVOLVEMENT OTHER THAN JOINTS",
         number: "4A"
      },
      "questions":[
         {
            "main":"Opthalmological",
            "dbqName":"form1[0].#subform[4].OPHTHALMOLOGICAL[0]",
            "answer":""
         },
         {
            "main":"Skin and mucous membranes",
            "dbqName":"form1[0].#subform[4].SKINMUCOUS[0]",
            "answer":""
         },
         {
            "main":"Hematological",
            "dbqName":"form1[0].#subform[4].HEMATOLOGIC[0]",
            "answer":""
         },
         {
            "main":"Pulmonary",
            "dbqName":"form1[0].#subform[4].PULMONARY[0]",
            "answer":""
         },
         {
            "main":"Cardiac",
            "dbqName":"form1[0].#subform[4].PULMONARY[1]",
            "answer":""
         },
         {
            "main":"Neurological",
            "dbqName":"form1[0].#subform[4].NEUROLOGIC[0]",
            "answer":""
         },
         {
            "main":"Renal",
            "dbqName":"form1[0].#subform[4].RENAL[0]",
            "answer":""
         },
         {
            "main":"Gastrointestinal",
            "dbqName":"form1[0].#subform[4].GASTROINTESTINAL[0]",
            "answer":""
         },
         {
            "main":"Vascular",
            "dbqName":"form1[0].#subform[4].VASCULAR[0]",
            "answer":""
         },
         {
            "main":"Other",
            "dbqName":"form1[0].#subform[4].VASCULAR[1]",
            "answer":""
         }       
      ],
      "answer":""
   },
   {
      "question":"For all checked systems, describe involvement (brief summary).",
      "sub":"",
      "type":"textarea",
      "maxLength":340,
      "show": false,
      "refId":2,
      "section": {
         page: "3",
         title: "SYSTEMIC INVOLVEMENT OTHER THAN JOINTS",
         number: "4A"
      },
      "options":[],
      "dbqName":"form1[0].#subform[4].BriefSummary[1]",
      "answer":""
   },

   {
      "question":"Please comment on systems involved if you have any",
      "sub":"",
      "type":"textarea",
      "maxLength":340,
      "optional": true,
      "show": true,
      "section": {
         page: "3",
         title: "SYSTEMIC INVOLVEMENT OTHER THAN JOINTS",
         number: "4B"
      },
      "dbqName":"form1[0].#subform[4].BriefSummary[2]",
      "answer":""
   },

   {
      "question":"Due to the arthritis condition, does ##name## have exacerbations which are not incapacitating?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "INCAPACITATING AND NON-INCAPACITATING EXACERBATIONS",
         number: "5A"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"form1[0].#subform[4].Yes11[0]",
      "dbqName_no":"form1[0].#subform[4].No11[0]",
      "answer":"",
   },
   {
      "question":"Indicate frequency of non-incapacitating exacerbations per year (on average)",
      "sub":"Check all that apply",
      "type":"radioModal",
      "multi": false,
      "show": false,
      "small": true,
      "cols": 2,
      "refId":1,
      "section": {
         page: "3",
         title: "INCAPACITATING AND NON-INCAPACITATING EXACERBATIONS",
         number: "5A"
      },
      "questions":[
         {
            "main":"No non-incapacitating exacerbations",
            "dbqName":"form1[0].#subform[4].zero[0]",
            "answer":"",
            "showSubItems": false,
            "date1": "",
            "placeholderDate1":"Date of most recent incapacitating exacerbation",
            "dbqDate1": "form1[0].#subform[4].DateExacerbation[0]",

            "text1": "",
            "dbqName1": "form1[0].#subform[4].Duration[1]",
            "placeholder1":"Duration of most recent incapacitating exacerbation",
            "rows1": 2,

            "text2": "",
            "dbqName2": "form1[0].#subform[4].Describe[1]",
            "placeholder2":"Describe incapacitating exacerbation",
            "rows2": 2,
         }, 
         {
            "main":"1 non-incapacitating exacerbations",
            "dbqName":"form1[0].#subform[4].one[0]",
            "answer":"",
            "showSubItems": false,
            "date1": "",
            "placeholderDate1":"Date of most recent incapacitating exacerbation",
            "dbqDate1": "form1[0].#subform[4].DateExacerbation[0]",

            "text1": "",
            "dbqName1": "form1[0].#subform[4].Duration[1]",
            "placeholder1":"Duration of most recent incapacitating exacerbation",
            "rows1": 2,

            "text2": "",
            "dbqName2": "form1[0].#subform[4].Describe[1]",
            "placeholder2":"Describe incapacitating exacerbation",
            "rows2": 2,
         }, 
         {
            "main":"2 non-incapacitating exacerbations",
            "dbqName":"form1[0].#subform[4].two[0]",
            "answer":"",
            "showSubItems": false,
            "date1": "",
            "placeholderDate1":"Date of most recent incapacitating exacerbation",
            "dbqDate1": "form1[0].#subform[4].DateExacerbation[0]",

            "text1": "",
            "dbqName1": "form1[0].#subform[4].Duration[1]",
            "placeholder1":"Duration of most recent incapacitating exacerbation",
            "rows1": 2,

            "text2": "",
            "dbqName2": "form1[0].#subform[4].Describe[1]",
            "placeholder2":"Describe incapacitating exacerbation",
            "rows2": 2,
         },
         {
            "main":"3 non-incapacitating exacerbations",
            "dbqName":"form1[0].#subform[4].three[0]",
            "answer":"",
            "showSubItems": false,
            "date1": "",
            "placeholderDate1":"Date of most recent incapacitating exacerbation",
            "dbqDate1": "form1[0].#subform[4].DateExacerbation[0]",

            "text1": "",
            "dbqName1": "form1[0].#subform[4].Duration[1]",
            "placeholder1":"Duration of most recent incapacitating exacerbation",
            "rows1": 2,

            "text2": "",
            "dbqName2": "form1[0].#subform[4].Describe[1]",
            "placeholder2":"Describe incapacitating exacerbation",
            "rows2": 2,
         },
         {
            "main":"4 or more non-incapacitating exacerbations",
            "dbqName":"form1[0].#subform[4].four[0]",
            "answer":"",
            "showSubItems": false,
            "date1": "",
            "placeholderDate1":"Date of most recent incapacitating exacerbation",
            "dbqDate1": "form1[0].#subform[4].DateExacerbation[0]",

            "text1": "",
            "dbqName1": "form1[0].#subform[4].Duration[1]",
            "placeholder1":"Duration of most recent incapacitating exacerbation",
            "rows1": 2,

            "text2": "",
            "dbqName2": "form1[0].#subform[4].Describe[1]",
            "placeholder2":"Describe incapacitating exacerbation",
            "rows2": 2,
         }                       
      ],
      "answer":""
   },

   {
      "question":"Due to the arthritis condition, does ##name## have exacerbations which are incapacitating?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "INCAPACITATING AND NON-INCAPACITATING EXACERBATIONS",
         number: "5B"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"form1[0].#subform[4].Yes12[0]",
      "dbqName_no":"form1[0].#subform[4].No12[0]",
      "answer":"",
   },
   {
      "question":"Indicate frequency of incapacitating exacerbations per year (on average)",
      "sub":"Check all that apply",
      "type":"radioModal",
      "multi": false,
      "show": false,
      "small": true,
      "cols": 2,
      "refId":1,
      "section": {
         page: "3",
         title: "INCAPACITATING AND NON-INCAPACITATING EXACERBATIONS",
         number: "5B"
      },
      "questions":[
         {
            "main":"No incapacitating exacerbations",
            "dbqName":"form1[0].#subform[4].zerob[0]",
            "answer":"",
            "showSubItems": false,
            "date1": "",
            "placeholderDate1":"Date of most recent incapacitating exacerbation",
            "dbqDate1": "form1[0].#subform[4].DateExacerbation[1]",

            "text1": "",
            "dbqName1": "form1[0].#subform[4].Duration[0]",
            "placeholder1":"Duration of most recent incapacitating exacerbation",
            "rows1": 2,

            "text2": "",
            "dbqName2": "form1[0].#subform[4].Describe[0]",
            "placeholder2":"Describe incapacitating exacerbation",
            "rows2": 2,

            "subItems": [
               {
                  "main":"< 1 week",
                  "dbqName":"form1[0].#subform[4].Box1[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"1 week to < 2 weeks",
                  "dbqName":"form1[0].#subform[4].Box2[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"2 weeks to < 4 weeks",
                  "dbqName":"form1[0].#subform[4].Box3[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"4 weeks to < 6 weeks",
                  "dbqName":"form1[0].#subform[4].Box4[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"6 weeks or more",
                  "dbqName":"form1[0].#subform[4].Box5[0]",
                  "colWidth": 6,
                  "answer":""
               }               
            ],
            "subAnswer":"",
            "subItemsLabel" :"Total duration of incapacitation over the past 12 months"
         }, 
         {
            "main":"1 incapacitating exacerbations",
            "dbqName":"form1[0].#subform[4].oneb[0]",
            "answer":"",
            "showSubItems": false,
            "date1": "",
            "placeholderDate1":"Date of most recent incapacitating exacerbation",
            "dbqDate1": "form1[0].#subform[4].DateExacerbation[1]",

            "text1": "",
            "dbqName1": "form1[0].#subform[4].Duration[0]",
            "placeholder1":"Duration of most recent incapacitating exacerbation",
            "rows1": 2,

            "text2": "",
            "dbqName2": "form1[0].#subform[4].Describe[0]",
            "placeholder2":"Describe incapacitating exacerbation",
            "rows2": 2,

            "subItems": [
               {
                  "main":"< 1 week",
                  "dbqName":"form1[0].#subform[4].Box1[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"1 week to < 2 weeks",
                  "dbqName":"form1[0].#subform[4].Box2[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"2 weeks to < 4 weeks",
                  "dbqName":"form1[0].#subform[4].Box3[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"4 weeks to < 6 weeks",
                  "dbqName":"form1[0].#subform[4].Box4[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"6 weeks or more",
                  "dbqName":"form1[0].#subform[4].Box5[0]",
                  "colWidth": 6,
                  "answer":""
               }               
            ],
            "subAnswer":"",
            "subItemsLabel" :"Total duration of incapacitation over the past 12 months"
         }, 
         {
            "main":"2 incapacitating exacerbations",
            "dbqName":"form1[0].#subform[4].twob[0]",
            "answer":"",
            "showSubItems": false,
            "date1": "",
            "placeholderDate1":"Date of most recent incapacitating exacerbation",
            "dbqDate1": "form1[0].#subform[4].DateExacerbation[1]",

            "text1": "",
            "dbqName1": "form1[0].#subform[4].Duration[0]",
            "placeholder1":"Duration of most recent incapacitating exacerbation",
            "rows1": 2,

            "text2": "",
            "dbqName2": "form1[0].#subform[4].Describe[0]",
            "placeholder2":"Describe incapacitating exacerbation",
            "rows2": 2,

            "subItems": [
               {
                  "main":"< 1 week",
                  "dbqName":"form1[0].#subform[4].Box1[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"1 week to < 2 weeks",
                  "dbqName":"form1[0].#subform[4].Box2[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"2 weeks to < 4 weeks",
                  "dbqName":"form1[0].#subform[4].Box3[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"4 weeks to < 6 weeks",
                  "dbqName":"form1[0].#subform[4].Box4[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"6 weeks or more",
                  "dbqName":"form1[0].#subform[4].Box5[0]",
                  "colWidth": 6,
                  "answer":""
               }               
            ],
            "subAnswer":"",
            "subItemsLabel" :"Total duration of incapacitation over the past 12 months"
         },
         {
            "main":"3 incapacitating exacerbations",
            "dbqName":"form1[0].#subform[4].threeb[0]",
            "answer":"",
            "showSubItems": false,
            "date1": "",
            "placeholderDate1":"Date of most recent incapacitating exacerbation",
            "dbqDate1": "form1[0].#subform[4].DateExacerbation[1]",

            "text1": "",
            "dbqName1": "form1[0].#subform[4].Duration[0]",
            "placeholder1":"Duration of most recent incapacitating exacerbation",
            "rows1": 2,

            "text2": "",
            "dbqName2": "form1[0].#subform[4].Describe[0]",
            "placeholder2":"Describe incapacitating exacerbation",
            "rows2": 2,

            "subItems": [
               {
                  "main":"< 1 week",
                  "dbqName":"form1[0].#subform[4].Box1[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"1 week to < 2 weeks",
                  "dbqName":"form1[0].#subform[4].Box2[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"2 weeks to < 4 weeks",
                  "dbqName":"form1[0].#subform[4].Box3[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"4 weeks to < 6 weeks",
                  "dbqName":"form1[0].#subform[4].Box4[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"6 weeks or more",
                  "dbqName":"form1[0].#subform[4].Box5[0]",
                  "colWidth": 6,
                  "answer":""
               }               
            ],
            "subAnswer":"",
            "subItemsLabel" :"Total duration of incapacitation over the past 12 months"
         },
         {
            "main":"4 or more incapacitating exacerbations",
            "dbqName":"form1[0].#subform[4].fourb[0]",
            "answer":"",
            "showSubItems": false,
            "date1": "",
            "placeholderDate1":"Date of most recent incapacitating exacerbation",
            "dbqDate1": "form1[0].#subform[4].DateExacerbation[1]",

            "text1": "",
            "dbqName1": "form1[0].#subform[4].Duration[0]",
            "placeholder1":"Duration of most recent incapacitating exacerbation",
            "rows1": 2,

            "text2": "",
            "dbqName2": "form1[0].#subform[4].Describe[0]",
            "placeholder2":"Describe incapacitating exacerbation",
            "rows2": 2,

            "subItems": [
               {
                  "main":"< 1 week",
                  "dbqName":"form1[0].#subform[4].Box1[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"1 week to < 2 weeks",
                  "dbqName":"form1[0].#subform[4].Box2[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"2 weeks to < 4 weeks",
                  "dbqName":"form1[0].#subform[4].Box3[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"4 weeks to < 6 weeks",
                  "dbqName":"form1[0].#subform[4].Box4[0]",
                  "colWidth": 6,
                  "answer":""
               },
               {
                  "main":"6 weeks or more",
                  "dbqName":"form1[0].#subform[4].Box5[0]",
                  "colWidth": 6,
                  "answer":""
               }               
            ],
            "subAnswer":"",
            "subItemsLabel" :"Total duration of incapacitation over the past 12 months"
         }                       
      ],
      "answer":""
   },

   {
      "question":"Is ##name##'s arthritis manifested by constitutional manifestations associated with active joint involvement which are totally incapacitating?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "4",
         title: "INCAPACITATING AND NON-INCAPACITATING EXACERBATIONS",
         number: "5C"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"form1[0].#subform[5].Yes13[0]",
      "dbqName_no":"form1[0].#subform[5].No13[0]",
      "answer":"",
   },
   {
      "question":"Is ##name##'s arthritis manifested by weight loss and anemia productive of severe impairment of health?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "4",
         title: "INCAPACITATING AND NON-INCAPACITATING EXACERBATIONS",
         number: "5D"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"form1[0].#subform[5].YesNo5D[1]",
      "dbqName_no":"form1[0].#subform[5].YesNo5D[0]",
      "answer":"",
   },
   {
      "question":"Is ##name##'s arthritis manifested by severely incapacitating exacerbations occurring four or more times a year, or a lesser number over prolonged periods?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "4",
         title: "INCAPACITATING AND NON-INCAPACITATING EXACERBATIONS",
         number: "5E"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"form1[0].#subform[5].YesNo5E[0]",
      "dbqName_no":"form1[0].#subform[5].YesNo5E[1]",
      "answer":"",
   },
   {
      "question":"Is ##name##'s  arthritis manifested by symptom combinations productive of definite impairment of health, objectively supported by examination findings?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "4",
         title: "INCAPACITATING AND NON-INCAPACITATING EXACERBATIONS",
         number: "5F"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"form1[0].#subform[5].YesNo5F[0]",
      "dbqName_no":"form1[0].#subform[5].YesNo5F[1]",
      "answer":"",
   },
   
   
   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
     "maxLength": 3900,
      "show": true,
      "section": {
         page: "6",
         title: "REMARKS",
         number: "11A"
      },
      "options":[],
      "dbqName":"form1[0].#subform[7].TextField6[11]",
      "answer":""
   },
]
   
    export default gout_questions ;